import { Box, Chip, Grid, Link, Tooltip, Typography } from "@mui/material";
import React from "react";
import { EntityDetailResponse } from "../../../../types/entityTypes";

interface SourceDetailProps {
  detailedSource: EntityDetailResponse;
  onEntityClick?: (entityId: string) => void;
}

const SourceDetail: React.FC<SourceDetailProps> = ({
  detailedSource,
  onEntityClick,
}) => {
  return (
    <Box sx={{ p: 0, flexShrink: 0 }}>
      <Grid container spacing={3}>
        {/* Source Overview Section */}
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "background.paper",
              p: 3,
              borderRadius: 2,
              border: 1,
              borderColor: "divider",
              mb: 1,
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ color: "primary.main", mb: 3 }}
            >
              Source Overview
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">
                  URL
                </Typography>
                {detailedSource?.s?.url ? (
                  <Link
                    href={detailedSource.s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ fontWeight: 500, wordBreak: "break-all" }}
                  >
                    {detailedSource.s.url}
                  </Link>
                ) : (
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    -
                  </Typography>
                )}
              </Grid>
              <Grid item xs={3}>
                <Typography variant="body2" color="text.secondary">
                  Domain
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {detailedSource?.s?.domain || "-"}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="body2" color="text.secondary">
                  Language
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {detailedSource?.s?.language || "-"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">
                  Authors
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {detailedSource?.s?.authors &&
                  detailedSource.s.authors.length > 0 ? (
                    <>
                      {detailedSource.s.authors
                        .slice(0, 6)
                        .map((author, index) => (
                          <Chip
                            key={index}
                            label={author}
                            color="info"
                            variant="outlined"
                            size="small"
                          />
                        ))}
                      {detailedSource.s.authors.length > 6 && (
                        <Tooltip
                          title={
                            <Box>
                              {detailedSource.s.authors
                                .slice(6)
                                .map((author, idx) => (
                                  <div key={idx}>{author}</div>
                                ))}
                            </Box>
                          }
                        >
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ ml: 1, alignSelf: "center", cursor: "help" }}
                          >
                            +{detailedSource.s.authors.length - 6} more
                          </Typography>
                        </Tooltip>
                      )}
                    </>
                  ) : (
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      -
                    </Typography>
                  )}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body2" color="text.secondary">
                  Publication Date
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                  {detailedSource?.s?.publication_date || "-"}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SourceDetail;
